import React from 'react';

const CaseStudyAddress = () => {
    const projectDetails = [
        { label: "Project Type", value: "PDF to BIM Conversion" },
        { label: "Project Name", value: "565 Pearl St." },
        { label: "Project Location", value: "California, USA" },
        { label: "Area", value: "73350 SQFT" },
        { label: "Time Duration", value: "7 working days" },
        { label: "Team Size", value: "3 BIM Modeler" },
        { label: "Software Used", value: "Revit 2025" },
        { label: "Project Completion Year", value: "2026" },
    ];

    const googleMapsUrl = "https://maps.google.com/maps?q=565%20Pearl%20St,%20La%20Jolla,%20CA%2092037,%20USA&t=&z=15&ie=UTF8&iwloc=&output=embed";
    const externalMapsUrl = "https://www.google.com/maps/search/?api=1&query=565+Pearl+St,+California,+USA";

    return (
        <section className="cs-address-section">
            <div className="cs-address-header">
                <h2 className="cs-address-main-title">
                    <span className="text-primary">PDF to BIM Conversion Project for 565</span> Pearl St, California, USA: Area 73350 Square Feet
                </h2>
            </div>

            <div className="cs-address-container">
                {/* Left: Project Details Table */}
                <div className="cs-details-box">
                    <h2 className="cs-details-title">Project Details</h2>
                    <div className="cs-details-table">
                        {projectDetails.map((detail, index) => (
                            <div key={index} className="cs-details-row">
                                <span className="cs-details-label">{detail.label}</span>
                                <span className="cs-details-value">{detail.value}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right: Real Map */}
                <div className="cs-map-box">
                    <div className="cs-map-wrapper">
                        <iframe 
                            src={googleMapsUrl}
                            width="100%" 
                            height="100%" 
                            style={{ border: 0 }} 
                            allowFullScreen="" 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Project Location"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CaseStudyAddress;
